export const BonusSubtypeDto = {
    BonusFunds: 'Bonus Funds',
    Wagering: 'Wagering',
    FreeSpins: 'Free Spins',
    HoneyToken: 'Honey Token',
    CashBonus: 'Cash Bonus',
} as const;
export type BonusSubtypeDto = typeof BonusSubtypeDto[keyof typeof BonusSubtypeDto];
